<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="6">
            <div style="font-size: 16px; font-weight: bold">
              <el-button style="padding: 3px 0" type="text" @click="back">
                <i class="el-icon-arrow-left"></i>
                返回
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <span> 加分考報考 </span>
            </div>
          </el-col>
        </el-row>
      </div>

       <br/>
         <el-row style="margin-left: 20px; font-size: 16px; line-height: 10px">
        <el-col :span="15">
          <el-row>
            <span style="font-size: 30px; font-weight: bold; line-height: 20px">{{
              sgName
            }}</span>
          </el-row>
          <br />
          <br />
          <el-row>
            <span style="font-weight: bold;font-size: 20px;; line-height: 20px">{{ id }}</span>
             <el-tag v-if="mothballType" type="danger" effect="plain" style="margin-left: 20px">已封存</el-tag>
             <el-tag v-else type="info" effect="plain" style="margin-left: 20px">未封存</el-tag>
          </el-row>
        </el-col>

        <el-col :span="9">
          <el-col :span="12">
            <div style="border-right: 2px #8f8f8f solid;border-left: 2px #8f8f8f solid; min-height: 50px">
              <div style="margin-left: 20px">
                <el-row>
                  <span>學年度</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span style="font-size: 20px; font-weight: bold; line-height: 20px">{{
                    year
                  }}</span>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div style=" min-height: 50px">
              <div style="margin-left: 20px">
                <el-row>
                  <span>學制班</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span style="font-size: 20px; font-weight: bold; line-height: 20px">{{
                    syTitel
                  }}</span>
                </el-row>
              </div>
            </div>
          </el-col>
         
        </el-col>
      </el-row>
      
      <el-divider></el-divider>

      <el-row style="margin-left: 30px" :gutter="20">
        <el-col :span="5">
          <span>書目 </span>
        </el-col>
        <el-col :span="5">
          <span>品項 </span>
        </el-col>
        <el-col :span="7">
          <span>編號範圍 </span>
        </el-col>
        <el-col :span="7">
          <el-button  type="primary" @click="saveAll()"
            >批次報考+通過</el-button
          >
          <el-button  type="danger" @click="deleteAll()">批次取消報考</el-button>
        </el-col>
      </el-row>

      <el-row style="margin-left: 30px" :gutter="20">
        <el-col :span="5">
          <el-select v-model="queryForm.book" filterable placeholder="請先輸入書目" @change="bookChange">
            <el-option
              v-for="item in bookList"
              :key="item.id"
              :label="item.id+item.bookName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <div v-loading="chapterLoading">
          <el-select v-model="queryForm.chapter" 
                     placeholder="再選擇品項" 
                     @change="chapterChange" 
                     :disabled="chapterList.length<2" 
                     clearable>
            <el-option
              v-for="item in chapterList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          </div>
        </el-col>
        <el-col :span="3">
          <el-input-number
            v-model="queryForm.rangeStart"
            :min="0"
            controls-position="right"
            :controls="false"
             @keyup.enter.native="query"
             style="width: 100%"
          ></el-input-number>
        </el-col>
        <el-col :span="0.5">
          <span style="margin-left: 10px; margin-right: -10px">~</span>
        </el-col>
        <el-col :span="3">
          <el-input-number
            v-model="queryForm.rangeEnd"
            :min="0"
            controls-position="right"
            :controls="false"
            @keyup.enter.native="query"
              style="width: 100%"
          ></el-input-number>
        </el-col>
      </el-row>

      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        @selection-change="isCheckRow"
      >
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column
          prop="id"
          label="編號"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="book"
          label="書目"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="chapter"
          label="品項"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="bookRange"
          label="分格範圍"
          width="200"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="apply"
          label="報考狀態"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="pass"
          fixed="right"
          label="通過與否"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <del v-if="scope.row.apply == '未報考'"></del>
            <div v-else-if="scope.row.pass" style="color: #7EBE50">通過</div>
            <div v-else style="color: #E57470">未通過</div>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
             <el-button
              v-if="scope.row.pass"
              type="danger"
              size="small"
              @click="passChange(scope.row)"
              >未通過</el-button
            >
            <el-button
              v-else-if="scope.row.apply!='未報考'"
              type="success"
              size="small"
              @click="passChange(scope.row)"
              >通過</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import { InformType } from "@/utils/InformType";

export default {
  name: "addPoints",

  data() {
    return {
      isLoading: false,
      chapterLoading:false,

      id:"",
      sgName:"",
      syTitel:"",
      year:"",

      tableData: [],
      bookList:[],
      chapterList:[],
      checkRow:[],

      queryForm: {
        book: "",
        chapter: "",
        rangeStart:undefined,
        rangeEnd:undefined,
      },
    };
  },

  created() {
    this.getBookList();
    this.getPerson();
  },

  methods: {
    query() {
      if(this.queryForm.book=="") return;
      console.log("讀取");
      this.isLoading = true;
      console.log(this.queryForm);
      API.bookList.showApply(this.$route.query.id,this.$route.query.pid,this.queryForm).then((res) => {
        this.tableData = res.data;
        console.log(res.data);
        this.isLoading = false;
      });
    },

    getBookList(){
      console.log("讀取書目");
      this.isLoading = true;
      API.addPointsApply.bookQuery().then((res) => {
        this.bookList = res.data;
        console.log(res.data);
        this.isLoading = false;
      });
    },

    getPerson(){
      console.log("讀取人員");
      this.isLoading = true;
      API.person.showIdSgname(this.$route.query.id,this.$route.query.pid).then((res) => {
        this.id = res.data.id;
        this.sgName = res.data.sgName;
        this.syTitel =res.data.sy;
        this.year=res.data.year;
        console.log(res.data);
        this.isLoading = false;
      });
    },

    bookChange(){
      if(Utils.Check.isNull(this.queryForm.book))
        return;
      this.queryForm.chapter="";
      this.queryForm.rangeStart=undefined,
      this.queryForm.rangeEnd=undefined,
      this.getChapter();
      this.query();
    },

    chapterChange(){
      if(Utils.Check.isNull(this.queryForm.book))
        return;
      this.queryForm.rangeStart=undefined,
      this.queryForm.rangeEnd=undefined,
      this.query();
    },

    getChapter(){
      console.log("讀取品項");
      this.chapterLoading = true;
      API.bookList.findChapter(this.queryForm.book).then((res) => {
        this.chapterList = res.data;
        console.log(res.data);
        this.chapterLoading = false;
      });
    },

    isCheckRow(val) {
      this.checkRow = val.map((item)=>{
        return item.id;
      });
      console.log("選中row: ", this.checkRow);
    },


    saveAll() {
      if (this.checkRow.length < 1) {
        Utils.Message.send("尚未勾選報考資料!", InformType.ERROR);
        return;
      }
      this.isLoading = true;
      console.log("報考");

      API.addPointsApply
        .saveAll(this.$route.query.id, this.$route.query.pid,this.checkRow)
        .then(() => {
          Utils.Message.send("報考成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.query();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },


    deleteAll() {
      if (this.checkRow.length < 1) {
        Utils.Message.send("尚未勾選取消報考資料!", InformType.ERROR);
        return;
      }
      this.isLoading = true;

      API.addPointsApply
        .deleteAll(this.$route.query.id, this.$route.query.pid,this.checkRow)
        .then(() => {
          Utils.Message.send("取消報考成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.query();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    passChange(row){
      API.addPointsApply
        .passChange(row.applyId)
        .then(() => {
          Utils.Message.send("通過狀態修改成功!", InformType.SUCCESS);
          row.pass=!row.pass;
        })
        .catch(() => {
          Utils.Message.send("通過狀態修改失敗!", InformType.ERROR);
        });
    },

    back() {
      this.$router.push({ path: `/addPoints?id=${this.$route.query.id}&pid=${this.$route.query.pid}`});
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>